(() => {
  function init(root) {
    if (root.dataset.storiesReady) return;
    root.dataset.storiesReady = 'true';
    const track = root.querySelector('.cg-story-track');
    const cards = [...track.querySelectorAll('.cg-story-card')];
    const dots = [...root.querySelectorAll('[data-story-go]')];
    if (!cards.length) return;
    const mobile = matchMedia('(max-width: 699px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let active = cards[Math.floor(cards.length / 2)];
    let engaged = false, timer, recentering = false, visible = true;
    const videoOf = card => card.querySelector('video');
    const center = (card, behavior = 'instant') => {
      const a = card.getBoundingClientRect(), b = track.getBoundingClientRect();
      track.scrollTo({left: track.scrollLeft + a.left + a.width / 2 - b.left - b.width / 2, behavior});
    };
    const pauseOthers = current => cards.forEach(card => {
      const video = videoOf(card);
      if (video && video !== current) video.pause();
    });
    function select(card, resume = true) {
      active = card;
      cards.forEach(c => c.classList.toggle('is-active', c === card));
      dots.forEach(dot => dot.setAttribute('aria-pressed', String(dot.dataset.storyGo === card.dataset.storyIndex)));
      const video = videoOf(card);
      pauseOthers(video);
      if (resume && engaged && visible && video) {
        if (video.ended) video.currentTime = 0;
        video.play().catch(() => {});
      }
    }
    // Keep one real neighboring slide on each side, without duplicated video elements.
    function balance() {
      if (cards.length < 3) return;
      recentering = true;
      if (track.firstElementChild === active) track.prepend(track.lastElementChild);
      else if (track.lastElementChild === active) track.append(track.firstElementChild);
      if (mobile.matches) center(active);
      requestAnimationFrame(() => { recentering = false; });
    }
    function settle() {
      if (!mobile.matches || recentering) return;
      const box = track.getBoundingClientRect(), middle = box.left + box.width / 2;
      const nearest = cards.reduce((best, card) => {
        const distance = el => { const r = el.getBoundingClientRect(); return Math.abs(r.left + r.width / 2 - middle); };
        return distance(card) < distance(best) ? card : best;
      });
      select(nearest);
      balance();
    }
    function go(card) {
      if (mobile.matches) {
        center(card, reduced.matches ? 'instant' : 'smooth');
        clearTimeout(timer); timer = setTimeout(settle, 450);
      } else { select(card); balance(); }
    }
    track.addEventListener('scroll', () => {
      if (recentering) return;
      clearTimeout(timer); timer = setTimeout(settle, 140);
    }, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.target.closest('video')) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const index = cards.indexOf(active), step = event.key === 'ArrowRight' ? 1 : -1;
      go(cards[(index + step + cards.length) % cards.length]);
    });
    cards.forEach(card => {
      const video = videoOf(card), poster = card.querySelector('.cg-video-poster');
      poster?.addEventListener('click', () => go(card));
      poster?.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); go(card); }
      });
      if (!video) return;
      const play = card.querySelector('.cg-story-play');
      video.controls = false;
      function syncPlayback() {
        card.classList.toggle('is-playing', !video.paused && !video.ended);
        play?.setAttribute('aria-label', video.paused || video.ended ? 'Play video' : 'Pause video');
      }
      play?.addEventListener('click', () => {
        if (!video.paused && !video.ended) video.pause();
        else {
          if (video.ended) video.currentTime = 0;
          video.play().catch(syncPlayback);
        }
      });
      video.addEventListener('pause', syncPlayback);
      video.addEventListener('ended', syncPlayback);
      video.addEventListener('play', () => {
        syncPlayback();
        engaged = true;
        select(card, false);
        if (mobile.matches) center(card, reduced.matches ? 'instant' : 'smooth');
      });
    });
    root.querySelectorAll('[data-story-step]').forEach(button => button.addEventListener('click', () => {
      go(cards[(cards.indexOf(active) + Number(button.dataset.storyStep) + cards.length) % cards.length]);
    }));
    dots.forEach(dot => dot.addEventListener('click', () => go(cards[Number(dot.dataset.storyGo)])));
    function layout() {
      recentering = true;
      cards.forEach(card => track.append(card));
      if (mobile.matches) { center(active); balance(); }
      else { track.scrollLeft = 0; recentering = false; }
      requestAnimationFrame(() => { recentering = false; });
    }
    mobile.addEventListener('change', layout);
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(layout, 100); });
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (!visible) cards.forEach(card => videoOf(card)?.pause());
    }, {threshold: .15}).observe(track);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) cards.forEach(card => videoOf(card)?.pause());
    });
    select(active, false);
    requestAnimationFrame(layout);
  }
  document.querySelectorAll('[data-cg-stories]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cg-stories]').forEach(init));
})();
